import React, { useState, useEffect } from 'react';
import Spinner from './Spinner';

export default function ImgLoader({
  src,
  className,
  alt,
  spinnerClassName,
}) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.addEventListener('load', () => setLoaded(true));
    img.src = src;
  }, [setLoaded]);

  return loaded ? (
    <img src={src} className={className} alt={alt} />
  ) : (
    <Spinner className={spinnerClassName} />
  );
}
